import OwtlabCore from './index';
import extend from './core/utils/extend';
import { recordEvent, recordEvents } from './record-events-server';
import { deferEvent, deferEvents, queueCapacity, queueInterval, recordDeferredEvents } from './defer-events';
import { extendEvent, extendEvents } from './extend-events';
import { getDatetimeIndex } from './helpers/getDatetimeIndex';
import { getUniqueId } from './helpers/getUniqueId';
import { deepExtend } from './utils/deepExtend';
import { timer } from './utils/timer';

// ------------------------
// Methods
// ------------------------
extend(OwtlabCore.prototype, {
  recordEvent,
  recordEvents,
});
extend(OwtlabCore.prototype, {
  deferEvent,
  deferEvents,
  queueCapacity,
  queueInterval,
  recordDeferredEvents,
});
extend(OwtlabCore.prototype, {
  extendEvent,
  extendEvents,
});

// ------------------------
// Helpers
// ------------------------
extend(OwtlabCore.helpers, {
  getDatetimeIndex,
  getUniqueId,
});

// ------------------------
// Utils
// ------------------------
extend(OwtlabCore.utils, {
  deepExtend,
  timer,
});

export const Owtlab = OwtlabCore; // deprecated, left for backward compatibility
export const OwtlabTracking = OwtlabCore;
module.exports = Owtlab;
